<template>
  <div>
    <myheader
      :backIntercept="true"
      @childBackEvent="back"
      headTitle="企业认证"
    ></myheader>
    <div
      class="header_extend_main"
      style="height: 100%"
      :style="{
        paddingBottom:
          authStyle === 0 && refereeAuthStyle === 0 ? '5.6rem' : '4.2rem',
      }"
    >
      <div class="header_extend_back"></div>
      <div class="header_extend_content_height vertical_flex">
        <div class="all_tips_content_card_padding8">
          <div class="text12 textcolor666">{{ "当前认证企业：" }}</div>
          <div class="text12 textcolormain font_weight_bold margin_top_5">
            选择认证方式
          </div>
          <div class="all_tips_input display_flex margin_top_2">
            <div
              class="width_flex all_height_line16 text14 textcolor333 font_weight_900"
            >
              {{ authStyleText }}
            </div>
            <div
              class="selectstyle all_height_line16 text14 textcolor333 font_weight_900 display_flex"
              style="padding-left: 1rem"
              @click="showBottomView()"
            >
              切换
            </div>
          </div>
        </div>
        <div
          style="flex: 1; position: relative; border-radius: 0.3rem"
          class="margin_top_8"
        >
          <div
            style="
              overflow-y: auto;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
            "
          >
            <div v-if="authStyle === 1">
              <div class="all_tips_content_card_padding8">
                <div>
                  <span
                    class="all_text text14 font_weight_900 textcolor333 all_tips_red_after"
                    style="width: 60%"
                    >企业法人授权委托书</span
                  >
                  <span
                    class="text14 textcolormain"
                    style="width: 40%"
                    @click="downTemplate()"
                    >点击下载授权书模板</span
                  >
                </div>
                <div class="text12 textcolor333 margin_top_5">
                  下载法定代表人授权书模版，填写授权信息并加盖公章，拍照或扫描后上传，需保证授权书上所有信息清晰可见。
                </div>
                <div class="all_text_center margin_top_5">
                  <van-uploader
                    accept="application/pdf,image/jpg,image/jpeg,image/png"
                    v-model="pdfFiles"
                    :before-read="beforeReadPDF"
                    :after-read="afterRead"
                  >
                    <div
                      v-show="pdfFiles.length == 0"
                      class="display_flex all_text_center"
                      style="
                        padding: 0 0.5rem;
                        border-radius: 0.1rem;
                        border: 1px solid #ccc;
                      "
                    >
                      <img
                        src="@/assets/images/upload_file.svg"
                        style="height: 0.8rem; margin: 0.5rem"
                      />
                      <div class="all_height_line18 text14 textcolor666">
                        上传文件
                      </div>
                    </div>
                  </van-uploader>
                  <div class="text10 textcolor999 margin_top_5">
                    请选择格式为pdf/jpg/jpeg/png的文件，大小限制为1.5M
                  </div>
                </div>
              </div>
              <div class="all_tips_content_card_padding8 margin_top_8">
                <div
                  class="text12 textcolor999 font_weight_bold all_tips_red_after"
                >
                  向e签平台的对公账户打款
                </div>
                <div class="horizontal_line margin_top_2"></div>
                <div class="text12 textcolormain margin_top_5">
                  请在48小时内完成打款
                </div>
                <div class="text12 textcolor666 margin_top_5">公司名称</div>
                <div class="all_tips_input" style="border-bottom: none">
                  <div
                    class="my_input all_height_line16 text12 textcolor333 font_weight_bold"
                  >
                    {{ corporateAccountInfo.companyName }}
                  </div>
                </div>
                <div class="text12 textcolor666 margin_top_5">开户行名称</div>
                <div class="all_tips_input" style="border-bottom: none">
                  <div
                    class="my_input all_height_line16 text12 textcolor333 font_weight_bold"
                  >
                    {{ corporateAccountInfo.bankDeposit }}
                  </div>
                </div>
                <div class="text12 textcolor666 margin_top_5">汇入银行账号</div>
                <div class="all_tips_input">
                  <div
                    class="my_input all_height_line16 text12 textcolor333 font_weight_bold"
                  >
                    {{ corporateAccountInfo.bankAccount }}
                  </div>
                </div>
                <div class="text12 textcolor666 margin_top_5">打款金额</div>
                <div
                  class="margin_top_2 display_flex"
                  style="align-items: center"
                >
                  <span class="text18 textcolormain font_weight_900">{{
                    corporateAccountInfo.payMoney
                  }}</span>
                  <span class="text11 textcolormain" style="margin-left: 1rem"
                    >请在48小时内完成线下打款，</span
                  >
                </div>
                <div
                  class="all_tips_red_after text14 textcolor666 margin_top_5"
                >
                  图形验证码
                </div>
                <div class="all_van_field" :class="{ isfocus: verifyFocus }">
                  <div class="display_inline_block" style="width: 65%">
                    <van-field
                      v-model="verifyCode"
                      type="number"
                      maxlength="6"
                      placeholder="请输入计算结果"
                      clearable
                      @focus="getFocus(1)"
                      @blur="onblur(1)"
                    >
                    </van-field>
                  </div>
                  <span
                    @click="getPictureImg()"
                    class="display_inline_block"
                    title="看不清,换一个"
                    style="width: 35%"
                  >
                    <img
                      :src="verifyImg"
                      style="height: 1.8rem; width: 6rem"
                      fill
                      title="看不清,换一个"
                  /></span>
                </div>
              </div>
              <!-- <div class="all_tips_content_card margin_top_10">
								<div class="all_text text14 font_weight_900 textcolor333 all_tips_red_after">经办人身份证照片
								</div>
								<div class="horizontal_flex flex_wrap margin_top_5">
									<div style="width: 50%;text-align: center;">
										<van-uploader accept="image/*" v-model="idCardFront" :before-read="beforeRead"
											:after-read="afterReadCF" preview-size="4rem"
											:preview-full-image="operFrontFilePreview">
											<img v-show="idCardFront.length==0" style="height: 4rem; "
												src="@/assets/images/kuan_gallery.svg">
										</van-uploader>
										<div class="text12 textcolor333 margin_top_2">点击上传正面照片</div>
									</div>
									<div style="width: 50%;margin: 0 auto;text-align: center;">
										<van-uploader accept="image/*" v-model="idCardBack" :before-read="beforeRead"
											:after-read="afterReadCB" preview-size="4rem"
											:preview-full-image="operBackFilePreview">
											<img v-show="idCardBack.length==0" style="height: 4rem; "
												src="@/assets/images/kuan_gallery.svg">
										</van-uploader>
										<div class="text12 textcolor333 margin_top_2">点击上传背面照片</div>
									</div>
								</div>
							</div> -->
            </div>
            <div v-else>
              <div class="all_tips_content_card_padding8">
                <div class="text12 textcolormain font_weight_bold">
                  法定代表人身份认证方式
                </div>
                <div class="margin_top_5 display_flex">
                  <div
                    class="display_block text16 all_text_center"
                    @click="refereeClick(0)"
                    :class="{
                      selectRefereeAuthStyle: refereeAuthStyle !== 0,
                      selectRefereeAuthStyled: refereeAuthStyle === 0,
                    }"
                    style="
                      width: 40%;
                      height: 2rem;
                      line-height: 2rem;
                      margin-left: 4%;
                      margin-right: 6%;
                      position: relative;
                      border-radius: 0.2rem;
                    "
                  >
                    人脸认证
                    <div style="position: absolute; right: 0; top: 0">
                      <div class="triangle-container">
                        <div class="rounded-triangle"></div>
                      </div>
                    </div>
                    <img
                      v-if="refereeAuthStyle === 0"
                      src="@/assets/images/u3360.svg"
                      style="
                        position: absolute;
                        right: -0.3rem;
                        top: -0.2rem;
                        width: 0.96rem;
                        height: 0.6rem;
                        transform: rotate(42deg);
                        border-radius: 0.2rem;
                      "
                    />
                    <img
                      v-if="refereeAuthStyle === 0"
                      src="@/assets/images/u3361.svg"
                      style="
                        position: absolute;
                        right: 0.05rem;
                        top: 0.05rem;
                        width: 0.25rem;
                        height: 0.2rem;
                      "
                    />
                  </div>
                  <div
                    class="display_block text16 all_text_center"
                    @click="refereeClick(1)"
                    :class="{
                      selectRefereeAuthStyle: refereeAuthStyle !== 1,
                      selectRefereeAuthStyled: refereeAuthStyle === 1,
                    }"
                    style="
                      width: 40%;
                      height: 2rem;
                      line-height: 2rem;
                      margin-right: 4%;
                      margin-left: 6%;
                      position: relative;
                      border-radius: 0.2rem;
                    "
                  >
                    手机号认证
                    <img
                      v-if="refereeAuthStyle === 1"
                      src="@/assets/images/u3360.svg"
                      style="
                        position: absolute;
                        right: -0.3rem;
                        top: -0.2rem;
                        width: 0.96rem;
                        height: 0.6rem;
                        transform: rotate(42deg);
                        border-radius: 0.2rem;
                      "
                    />
                    <img
                      v-if="refereeAuthStyle === 1"
                      src="@/assets/images/u3361.svg"
                      style="
                        position: absolute;
                        right: 0.05rem;
                        top: 0.05rem;
                        width: 0.25rem;
                        height: 0.2rem;
                      "
                    />
                  </div>
                </div>
                <div class="text12 textcolor333 margin_top_10">
                  法定代表人实名信息
                </div>
                <div class="text14 textcolor666 margin_top_5">姓名</div>
                <div
                  class="all_van_field"
                  :class="{ isfocus: refereeIdNameFocus }"
                >
                  <van-field
                    v-model="refereeIdName"
                    type="text"
                    placeholder="请输入法定代表人姓名"
                    clearable
                    readonly
                    @focus="getFocus(2)"
                    @blur="onblur(2)"
                  >
                  </van-field>
                </div>
                <div class="text14 textcolor666 margin_top_5">身份证号码</div>
                <div
                  class="all_van_field"
                  :class="{ isfocus: refereeIdCodeFocus }"
                >
                  <van-field
                    v-model="refereeIdCode"
                    type="text"
                    placeholder="请输入法定代表人身份证号码"
                    clearable
                    readonly
                    @focus="getFocus(3)"
                    @blur="onblur(3)"
                  >
                  </van-field>
                </div>
                <div v-if="refereeAuthStyle === 1">
                  <div
                    class="all_tips_red_after text14 textcolor666 margin_top_5"
                  >
                    手机号
                  </div>
                  <div
                    class="all_input all_height30"
                    :class="{ isfocus: refereePhoneFocus }"
                  >
                    <van-field
                      v-model="refereePhone"
                      type="number"
                      maxlength="30"
                      placeholder="请输入手机号"
                      clearable
                      @focus="getFocus(4)"
                      @blur="onblur(4)"
                    >
                    </van-field>
                  </div>
                  <div
                    class="all_tips_red_after text14 textcolor666 margin_top_5"
                  >
                    图形验证
                  </div>
                  <div
                    class="all_input all_height30"
                    :class="{ isfocus: refereeVerifyCodeFocus }"
                  >
                    <div class="display_inline_block" style="width: 65%">
                      <van-field
                        type="number"
                        placeholder="请输入计算结果"
                        v-model="refereeVerifyCode"
                        @focus="getFocus(5)"
                        @blur="onblur(5)"
                        maxlength="6"
                        clearable
                      >
                      </van-field>
                    </div>
                    <span
                      @click="getPictureImg()"
                      class="display_inline_block"
                      title="看不清,换一个"
                      style="width: 35%"
                    >
                      <img
                        :src="verifyImg"
                        style="height: 1.8rem; width: 6rem"
                        fill
                        title="看不清,换一个"
                    /></span>
                  </div>
                  <div
                    class="all_tips_red_after text14 textcolor666 margin_top_5"
                  >
                    验证码
                  </div>
                  <div
                    class="all_input all_height30"
                    :class="{ isfocus: refereeSmsCodeFocus }"
                  >
                    <div class="display_inline_block" style="width: 60%">
                      <van-field
                        v-model="refereeSmsCode"
                        type="number"
                        maxlength="6"
                        placeholder="请输入短信验证码"
                        clearable
                        @focus="getFocus(6)"
                        @blur="onblur(6)"
                      />
                    </div>
                    <span
                      @click="getRefereeCode()"
                      class="display_inline_block text14 all_text_right all_line_height20"
                      style="width: 35%"
                      :class="{
                        textcolormain: timer === 60,
                        textcolor999: timer != 60,
                      }"
                    >
                      {{
                        timer === 60 ? "获取验证码" : timer + "s后再次获取"
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="all_tips_bottom_card">
          <van-checkbox
            v-if="authStyle === 0 && refereeAuthStyle === 0"
            class="text12 textcolor333"
            v-model="checked"
            style="margin-bottom: 0.5rem"
            >我同意石化e签采集人脸识别数据用于认证服务</van-checkbox
          >
          <button
            class="all_button22 width_100 text16 bmain_active"
            @click="jump()"
          >
            提交
          </button>
        </div>
      </div>
    </div>
    <van-popup v-model:show="showBottom" :overlay="true" position="bottom">
      <div class="selectStyleList">
        <div class="horizontal_line"></div>
        <div
          class="style backgroundC_white bwhite_ative display_flex"
          @click="selectType(0)"
        >
          <img
            style="width: 2rem; height: 2.3rem; margin: 0.5rem 0.8rem"
            src="@/assets/images/attorney_auth.svg"
          />
          <div class="display_inline_block" style="flex: 1">
            <div>
              <span
                class="all_height_line16 text14 textcolor333 font_weight_900"
                >法定代表人认证</span
              >
              <span class="timetips text10" style="margin-left: 1rem"
                >2分钟</span
              >
            </div>
            <div class="text12 textcolormain">
              需企业法人本人亲自进行实名认证，认证通过后即可完成企业认证
            </div>
          </div>
        </div>
        <div class="horizontal_line"></div>
        <div
          class="style backgroundC_white bwhite_ative display_flex"
          @click="selectType(1)"
        >
          <img
            style="width: 2rem; height: 2.3rem; margin: 0.5rem 0.8rem"
            src="@/assets/images/legal_auth.svg"
          />
          <div class="display_inline_block" style="flex: 1">
            <div>
              <span
                class="all_height_line16 text14 textcolor333 font_weight_900"
                >法人授权认证</span
              >
              <span class="timetips text10" style="margin-left: 1rem"
                >2个工作日</span
              >
            </div>
            <div class="text12 textcolormain">
              需企业法人本人亲自进行实名认证，认证通过后即可完成企业认证
            </div>
          </div>
        </div>
        <div class="horizontal_line"></div>
        <div style="height: 0.5rem; background-color: #ededed"></div>
        <div class="horizontal_line"></div>
        <div
          class="all_height_line24 text14 textcolor999 all_text_center"
          @click="showBottom = false"
        >
          取&nbsp;消
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  Field,
  Uploader,
  Step,
  Steps,
  Checkbox,
} from 'vant';
import {
  realLiveAuth,
  initIosAuth
} from '../../../utils/nativeRealLiveAuth.js';
import {
  saveFileToDevice,
  closeCurrentPage
} from '../../../utils/nativeOtherOperate.js';
export default {
  name: 'authenterpriselegal',
  components: {
    [Field.name]: Field,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Uploader.name]: Uploader,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      //企业id
      corpId: '',
      //重新认证
      reAuth: '',
      //认证方式
      showBottom: false,
      //
      checked: false,
      //认证方式
      authStyle: 0,
      //企业方式
      authStyleText: '法定代表人认证',
      //授权书文件
      pdfFiles: [],
      //授权书文件Id
      pdfFileId: '',
      //授权书文件Id
      pdfFileName: '',
      //图片验证结果
      verifyFocus: false,
      verifyCode: '',
      //验证Id
      verifyId: '',
      //验证图片
      verifyImg: '',
      //法人实人认证 认证方式
      refereeAuthStyle: 0,
      //
      refereeIdNameFocus: false,
      refereeIdName: '',
      //
      refereeIdCodeFocus: false,
      refereeIdCode: '',
      //
      refereePhoneFocus: false,
      refereePhone: '',
      //
      refereeVerifyCodeFocus: false,
      refereeVerifyCode: '',
      //
      refereeSmsCodeFocus: false,
      refereeSmsCode: '',
      //
      refereeRequestId: '',
      //验证码倒计时
      timer: 60,
      //
      enterpriseAuthInfo: '',
      //对公账户信息
      corporateAccountInfo: {
        companyName: '北京国富安电子商务安全认证有限公司',
        bankDeposit: '工商银行北京经济技术开发区宏达北路支行',
        bankAccount: '0200059009024509383',
        payMoney: '0.01元',
      },
    }
  },
  //拦截设置前进或后退
  beforeRouteLeave(to, from, next) {
    console.log("auth2-beforeRouteLeave", to, from);
    if (to.name === 'authenterpriseinfo') {
      this.$store.commit('changeEnterpriseAuthDirection', 2)
    } else {
      this.$store.commit('changeEnterpriseAuthDirection', 1)
      this.$store.commit("changeEnterpriseAuthInfo", {})
    }
    next();
  },
  methods: {
    back() {
      if (this.$route.query.appCode) {
        closeCurrentPage()
      } else {
        this.$router.go(-1)
      }
    },
    //
    getBackFlag() {
      let backFlag = true
      if (this.$store.state.sourceFlag) {
        backFlag = false
      }
      return backFlag
    },
    //限制只能使用授权书认证
    showBottomView() {
      if (this.refereeIdCode === this.$store.state.userInfo.idCode) {
        this.showBottom = true
      }
    },
    //下一步
    // certifyWay 类型
    // CorpCertifyWayEnum {
    //     UNKNOWN(0,"未指定"),
    //     FACE_PAY(1,"法人人脸+对平台打款"),
    //     AUTH_PAY(2,"法人授权书+对平台打款"),
    //     AUTH_PAY2(3,"法人授权书+对企业打款"),
    //     SHARE(4,"共享认证"),
    //     FACE(5,"法人人脸认证"),
    //     MOBILE(6,"法人手机认证"),
    //     FOUR(7,"四要素认证");
    // }
    //提交信息或实人认证，提交信息后跳转企业认证状态页面
    jump() {
      let authInfo = ''
      if (this.authStyle === 1) {
        if (!this.pdfFileId || !this.pdfFileName) {
          this.$Toast('请上传授权书文件！')
          return
        }
        if (!this.verifyId || !this.verifyCode) {
          this.$Toast('请输入图形验证码计算结果！')
          return
        }
        authInfo = {
          certifyWay: 2,
          applierCode: this.$store.state.userInfo.staffCode,
          applierName: this.$store.state.userInfo.staffName,
          corpId: this.enterpriseAuthInfo.corpId,
          corpName: this.enterpriseAuthInfo.corpName,
          creditCode: this.enterpriseAuthInfo.creditCode,
          legalPerson: this.refereeIdName,
          legalPersonIdCode: this.refereeIdCode,
          authApply: {
            authFileId: this.pdfFileId,
            authFileName: this.pdfFileName,
            bankAccount: this.corporateAccountInfo.bankAccount,
            bankDeposit: this.corporateAccountInfo.bankDeposit,
            companyName: this.corporateAccountInfo.companyName,
            verify: {
              code: this.verifyCode,
              id: this.verifyId
            }
          }
        }
      } else {
        if (this.refereeAuthStyle === 0) {
          //调用法人实人认证
          realLiveAuth({
            type: '1',
            legalName: this.refereeIdName,
            legalCode: this.refereeIdCode
          })
          return
        } else {
          this.refereePhone = this.refereePhone.trim()
          let reg = /^1[0-9]{10}$/;
          if (
            this.refereePhone &&
            this.refereePhone.length == 11 &&
            reg.test(this.refereePhone)
          ) {
            if (!this.refereeSmsCode) {
              this.$Toast("请输入短信验证码！")
              return
            }
            authInfo = {
              certifyWay: 6,
              applierCode: this.$store.state.userInfo.staffCode,
              applierName: this.$store.state.userInfo.staffName,
              corpId: this.enterpriseAuthInfo.corpId,
              corpName: this.enterpriseAuthInfo.corpName,
              creditCode: this.enterpriseAuthInfo.creditCode,
              legalPerson: this.refereeIdName,
              legalPersonIdCode: this.refereeIdCode,
              legalApply: {
                mobileArgs: {
                  mobile: this.refereePhone,
                  smsCode: this.refereeSmsCode
                }
              }
            }
          } else {
            this.$Toast("请输入正确的手机号！");
          }
        }
      }
      this.submitAgentApply(authInfo)
    },
    //法人实人认证后提交
    legalFaceAuthSubmit() {
      if (!this.refereeRequestId) {
        this.$Toast('请完成人脸实人认证！')
        return
      }
      const data = {
        certifyWay: 5,
        applierCode: this.$store.state.userInfo.staffCode,
        applierName: this.$store.state.userInfo.staffName,
        corpId: this.enterpriseAuthInfo.corpId,
        corpName: this.enterpriseAuthInfo.corpName,
        creditCode: this.enterpriseAuthInfo.creditCode,
        legalPerson: this.refereeIdName,
        legalPersonIdCode: this.refereeIdCode,
        legalApply: {
          faceArgs: {
            certifyTime: this.Tool.getDataISOString(new Date().toISOString()),
            requestId: this.refereeRequestId
          }
        }
      }
      this.submitAgentApply(data)
    },
    //企业认证信息提交 提交代理申请
    submitAgentApply(data) {
      this.$store.dispatch(this.$LoadShow, true)
      this.$post('/corp/api/submitAgentApply', data).then(res => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success) {
          let applyStatus = 2
          if (this.authStyle === 0) {
            this.$Toast("认证成功！");
            applyStatus = 2
          } else {
            applyStatus = 1
            this.$Toast("提交成功！");
          }
          this.$router.push({
            path: '/authenterprisestatus',
            query: {
              applyStatus: applyStatus,
              corpId: this.corpId,
              reAuth: this.reAuth,
              refresh: 1,
            }
          })
        } else {
          this.$Toast(res.message || res.messageDetail || "认证失败，请重试！");
          this.getPictureImg()
        }
      }).catch(err => {
        this.$Toast("认证失败，请重试！");
        this.$store.dispatch(this.$LoadShow, false)
        this.getPictureImg()
      })
    },
    //下载授权委托书
    downTemplate() {
      if (plus.os.name === 'iOS') {
        this.$Toast('请选择要下载的目录...')
      }
      saveFileToDevice(window.location.origin + '/templates/法人授权委托书.docx', '法人授权委托书.docx')
      if (plus.os.name === 'Android') {
        this.$Toast('下载到目录：Download/法人授权委托书.docx！')
      }
    },
    //授权书文件长传前 pdf png、jpg、jpeg
    beforeReadPDF(file) {
      //console.log(file)
      if (file.type != 'application/pdf' && file.type != 'image/jpeg' && file.type != 'image/png' && file.type !=
        'image/jpg') {
        this.$Toast('请上传pdf文件');
        return false;
      }
      return true;
    },
    //授权书文件长传后
    afterRead(file) {
      console.log(file)
      console.log(this.pdfFiles)
      this.uploadFile('pdf', file.file)
    },
    //上传pdf文件
    uploadFile(flag, file) {
      this.$store.dispatch(this.$LoadShow, true)
      this.$post('/file/api/uploadFile', {
        resId: this.Tool.generateUUID(),
        file: file
      }, 'form')
        .then((res) => {
          this.$store.dispatch(this.$LoadShow, false)
          if (res.success && res.data) {
            file.status = 'success';
            file.message = '上传成功';
            if (flag === 'pdf') {
              this.pdfFileId = res.data.fileId
              this.pdfFileName = res.data.fileName
            }
          } else {
            file.status = 'failed';
            file.message = '上传失败';
          }
        }).catch(err => {
          this.$Toast("上传文件失败，请重试！");
          this.$store.dispatch(this.$LoadShow, false)
          console.log('/file/api/uploadFile', err)
        })
    },
    //法人实人认证成功
    legalFaceAuthSucced(requestId) {
      this.$store.dispatch(this.$LoadShow, false)
      this.refereeRequestId = requestId
      this.legalFaceAuthSubmit()
    },
    //法人实人认证失败
    legalFaceAuthFailed(msg) {
      this.$store.dispatch(this.$LoadShow, false)
      this.$Toast(msg || '实人认证失败，请重新认证！')
    },
    //向企业法人发送验证码
    getRefereeCode() {
      if (this.timer != 60) {
        return
      }
      this.refereePhone = this.refereePhone.trim()
      let reg = /^1[0-9]{10}$/;
      if (
        this.refereePhone &&
        this.refereePhone.length == 11 &&
        reg.test(this.refereePhone)
      ) {
        if (!this.verifyId || !this.refereeVerifyCode) {
          this.$Toast("请输入图片验证码计算结果！");
          return
        }
        this.refereeSmsCode = ''
        this.$store.dispatch(this.$LoadShow, true)
        this.$post("/corp/api/sendSmsCode", {
          mobile: this.refereePhone,
          type: 0,
          verify: {
            id: this.verifyId,
            code: this.refereeVerifyCode
          },
        }).then((res) => {
          this.$store.dispatch(this.$LoadShow, false)
          if (res.success) {
            this.$Toast("验证码已发送，请注意查收！");
            this.timer--;
            var timer1 = setInterval(() => {
              this.timer--;
              if (this.timer == 0) {
                this.timer = 60;
                clearTimeout(timer1);
              }
            }, 1000);
          } else {
            this.$Toast(res.message || res.messageDetail || "获取验证码失败！")
            this.getPictureImg()
          }
        }).catch(err => {
          this.$store.dispatch(this.$LoadShow, false)
          this.getPictureImg()
        })
      } else {
        this.$Toast("请输入正确的手机号！");
      }
    },
    //获取焦点
    getFocus(id) {
      switch (id) {
        case 1:
          this.verifyFocus = true
          break;
        case 2:
          //this.refereeIdNameFocus = true
          break;
        case 3:
          //this.refereeIdCodeFocus = true
          break;
        case 4:
          this.refereePhoneFocus = true
          break;
        case 5:
          this.refereeVerifyCodeFocus = true
          break;
        case 6:
          this.refereeSmsCodeFocus = true
          break;
      }
    },
    //失去焦点
    onblur(id) {
      switch (id) {
        case 1:
          this.verifyFocus = false
          break;
        case 2:
          //this.refereeIdNameFocus = false
          break;
        case 3:
          //this.refereeIdCodeFocus = false
          break;
        case 4:
          this.refereePhoneFocus = false
          break;
        case 5:
          this.refereeVerifyCodeFocus = false
          break;
        case 6:
          this.refereeSmsCodeFocus = false
          break;
      }
    },
    //法定代表人认证方式 // 0人脸，1手机号
    refereeClick(type) {
      if (this.refereeAuthStyle != type) {
        this.refereeAuthStyle = type
        if (this.refereeAuthStyle === 1) {
          this.getPictureImg()
        }
      }
    },
    //法人认证方式 0 授权书+打款认证，法人实人认证
    selectType(type) {
      this.authStyle = type
      switch (this.authStyle) {
        case 0:
          this.authStyleText = '法定代表人认证'
          break;
        case 1:
          this.authStyleText = '法人授权认证'
          break;
      }
      this.showBottom = false
    },
    //获取认证图片
    getPictureImg() {
      this.verifyCode = ''
      this.$store.dispatch(this.$LoadShow, true)
      this.$get('/corp/api/getImageCode').then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success && res.data) {
          this.verifyId = res.data.verifyId
          this.verifyImg = res.data.srcImg
        } else {
          this.verifyImg = ''
          this.$Toast("未获取到验证图片！");
        }
      }).catch((err) => {
        this.verifyImg = ''
        this.$store.dispatch(this.$LoadShow, false)
        console.log('getImageCode', err)
      });
    },
    //获取重新认证信息
    getReAuthEditAgentApplyInfo() {
      this.$get('/corp/api/getEditAgentApply?corpId=' + this.corpId).then(res => {
        if (res.success && res.data) {
          this.enterpriseAuthInfo = res.data
          if (res.data.certifyWay == 2) {
            this.selectType(1)
            //todo 设置文件
          } else if (res.data.certifyWay == 5) {
            this.selectType(0)
            this.refereeAuthStyle = 0
            //shezhi 
            this.refereeIdName = res.data.legalPerson
            this.refereeIdCode = res.data.legalPersonIdCode
          } else if (res.data.certifyWay == 6) {
            this.selectType(0)
            this.refereeAuthStyle = 1
            this.refereeIdName = res.data.legalPerson
            this.refereeIdCode = res.data.legalPersonIdCode
          } else {
            this.selectType(0)
            this.refereeAuthStyle = 0
            this.refereeIdName = res.data.legalPerson
            this.refereeIdCode = res.data.legalPersonIdCode
          }
          if (this.refereeIdCode != this.$store.state.userInfo.idCode) {
            this.selectType(1)
          }
        } else {
          this.$Toast("未获取上次提交得信息！");
        }
      }).catch(err => {
        console.log('getEditAgentApply', err)
      })
    },
    //初始化
    init() {
      console.log('enterpriseAuthInfo', this.$store.state.enterpriseAuthInfo)
      //console.log(this.$store.state.enterpriseAuthInfo)
      this.corpId = this.$route.query.corpId
      this.reAuth = this.$route.query.reAuth
      // if (this.$route.query.appCode) {
      // 	this.$store.dispatch(this.$addSourceFlag, this.$route.query.appCode)
      // }
      this.getPictureImg()
      if (this.reAuth) {
        this.getReAuthEditAgentApplyInfo()
      } else {
        this.enterpriseAuthInfo = this.$store.state.enterpriseAuthInfo
        this.refereeIdName = this.enterpriseAuthInfo.legalPerson
        this.refereeIdCode = this.enterpriseAuthInfo.legalPersonIdCode
        if (this.refereeIdCode != this.$store.state.userInfo.idCode) {
          this.selectType(1)
        }
      }
      //ios版每次使用前需要初始化
      initIosAuth()
    },
  },
  mounted() {
    this.init()
  },
  created() {
    window.legalFaceAuthSucced = this.legalFaceAuthSucced
    window.legalFaceAuthFailed = this.legalFaceAuthFailed
  },
  beforeDestroy() { }
}
	/*//身份证正面
      beforeRead(file) {
        if (file.type === 'image/*') {
          this.$Toast('请选择图片文件');
          return false;
        }
        //console.log(file)
        return true;
      },
      afterReadCF(file) {
        //console.log(file)
        this.operFrontFilePreview = true
        file.status = 'uploading';
        file.message = '上传中...';
        if (file.file.size > 524288) {
          this.Tool.compressImage(file, 512, false).then((res) => {
            this.uploadBase64('cf', file, res.data)
          })
        } else {
          this.uploadBase64('cf', file, file.content)
        }
      },
      //身份证背面
      afterReadCB(file) {
        //console.log(file)
        this.operBackFilePreview = true
        file.status = 'uploading';
        file.message = '上传中...';
        if (file.file.size > 524288) {
          this.Tool.compressImage(file, 512, false).then((res) => {
            this.uploadBase64('cb', file, res.data)
          })
        } else {
          this.uploadBase64('cb', file, file.content)
        }
      },
      //上传营业执照，身份证正反面
      uploadBase64(flag, file, data) {
        this.$post('/file/api/saveBase64?resId=' + this.Tool.generateUUID(), {
            base64Data: data,
            clearBg: false,
            fileName: file.file.name
          })
          .then((res) => {
            if (res.success && res.data) {
              file.status = 'success';
              file.message = '上传成功';
              switch (flag) {
                case 'cf':
                  this.operFrontFileId = res.data.fileId
                  //缓存数据
                  //this.$store.state.enterpriseAuthInfo.operFrontFileBase64 = data
                  break;
                case 'cb':
                  this.operBackFileId = res.data.fileId
                  //this.$store.state.enterpriseAuthInfo.operBackFileBase64 = data
                  break;
              }
            } else {
              file.status = 'failed';
              file.message = '上传失败';
            }
          }).catch(err => {
            console.log('/file/api/saveBase64', err)
          })
      },
      //获取文件base64
      getBase64(flag, fileId) {
        if (!this.Tool.isNoEmpty(fileId)) {
          return
        }
        this.$store.dispatch(this.$LoadShowLevel, true)
        this.$get('/file/api/downloadBase64no/' + fileId)
          .then((res) => {
            this.$store.dispatch(this.$LoadShowLevel, false)
            if (res.success && res.data) {
              let base64 = 'data:image/png;base64,' + res.data
              switch (flag) {
                case 'of':
                  this.idCardFront.push({
                    content: base64
                  })
                  //缓存数据
                  this.$store.state.enterpriseAuthInfo.operFrontFileBase64 = base64
                  this.$store.state.enterpriseAuthInfo.operFrontFileId = this.operFrontFileId
                  break;
                case 'ob':
                  this.idCardBack.push({
                    content: base64
                  })
                  this.$store.state.enterpriseAuthInfo.operBackFileBase64 = base64
                  this.$store.state.enterpriseAuthInfo.operBackFileId = this.operBackFileId
                  break;
              }
            }
          })
      },*/
</script>

<style scoped lang="scss">
@import "../../../styles/global.css";

::v-deep .van-image__img {
  object-fit: contain !important;
}

::v-deep .van-cell {
  padding: 0.5rem 0.2rem;
}

.selectRefereeAuthStyle {
  border: solid 1px #ccc;
}

.selectRefereeAuthStyled {
  border: solid 1px #0277fc;
}
</style>